<div>
  <p class="text">{{ Texts.title }}</p>

  <div [formGroup]="instrumentDescription" class="row">
    <div class="col-6">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.instrumentType }}</mat-label>
        <mat-select
          formControlName="instrumentType"
          (selectionChange)="instrumentChange()"
        >
          <mat-option
            *ngFor="let instrumentType of instrumentTypes"
            [value]="instrumentType.name"
          >
            {{ instrumentType.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-6">
      <mat-form-field appearance="outline">
        <mat-label
          >{{ Texts.instrumentNumber }}
          <span *ngIf="requireds">*</span></mat-label
        >
        <input type="text" matInput formControlName="instrumentNumber" />
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.agency }} <span *ngIf="requireds">*</span></mat-label>
        <input type="text" matInput formControlName="agency" />
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.openingDate }} <span *ngIf="requireds">*</span></mat-label>
        <input type="date" matInput formControlName="openingDate" />
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.deadline }} </mat-label>
        <input type="date" matInput formControlName="deadline" />
      </mat-form-field>
    </div>
  </div>
  
</div>